import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants'

export default class IsMobileBreakpoint {
  constructor() {
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.isMobile = undefined

    this.init()
  }

  init() {
    this.handleCondition()
    this.registerEvents()
  }

  registerEvents() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.RESIZE, this.handleCondition.bind(this))
  }

  handleCondition(event) {
    const isMobileNow = window.innerWidth < GLOBAL_CONSTANTS.BREAKPOINTS.mobile
    if (isMobileNow === this.isMobile) {
      return
    }
    this.emitter.emit(GLOBAL_CONSTANTS.EVENTS.IS_MOBILE, {
      isMobile: isMobileNow,
      isFirstLoad: event === undefined
    })
    this.isMobile = isMobileNow
  }
}
